document.addEventListener('DOMContentLoaded', function () {
  const tagElements = document.querySelectorAll('.for-retail__why-tr__inner__tags__elem');
  const infoItems = document.querySelectorAll('.for-retail__why-tr__inner__info__item');

  const infoContainer = document.querySelector('.for-retail__why-tr__inner__info');
  if (infoContainer) {
    infoContainer.classList.add('first-tab-active');
  }

  function scrollActiveTagIntoView() {
    const tagsContainer = document.querySelector('.for-retail__why-tr__inner__tags');
    if (!tagsContainer) return;
    const activeTag = tagsContainer.querySelector('.for-retail__why-tr__inner__tags__elem.active');
    if (!activeTag) return;

    const styles = window.getComputedStyle(tagsContainer);
    const isRow = styles.flexDirection.includes('row');

    if (isRow) {
      const left = activeTag.offsetLeft;
      tagsContainer.scrollTo({ left, behavior: 'smooth' });
    } else {
      const top = activeTag.offsetTop;
      tagsContainer.scrollTo({ top, behavior: 'smooth' });
    }
  }

  function switchToTab(index) {
    if (index < 0) index = tagElements.length - 1;
    if (index >= tagElements.length) index = 0;

    tagElements.forEach((t) => t.classList.remove('active'));
    tagElements[index].classList.add('active');

    infoItems.forEach((item) => item.classList.remove('active'));
    if (infoItems[index]) {
      infoItems[index].classList.add('active');
    }

    const infoContainer = document.querySelector('.for-retail__why-tr__inner__info');

    if (index === 0) {
      infoContainer.classList.add('first-tab-active');
      infoContainer.classList.remove('last-tab-active');
    } else if (index === tagElements.length - 1) {
      infoContainer.classList.add('last-tab-active');
      infoContainer.classList.remove('first-tab-active');
    } else {
      infoContainer.classList.remove('first-tab-active');
      infoContainer.classList.remove('last-tab-active');
    }

    scrollActiveTagIntoView();
  }

  tagElements.forEach((tag, index) => {
    tag.addEventListener('click', function () {
      switchToTab(index);
    });
  });

  infoItems.forEach((item) => {
    let touchStartX = 0;
    let touchEndX = 0;

    item.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true },
    );

    item.addEventListener(
      'touchmove',
      function (e) {
        const currentX = e.changedTouches[0].screenX;
        const horizontalDistance = Math.abs(currentX - touchStartX);
        const minDistance = 10;

        if (horizontalDistance > minDistance) {
          e.preventDefault();
        }
      },
      { passive: false },
    );

    item.addEventListener(
      'touchend',
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      },
      { passive: true },
    );

    function handleSwipe() {
      const swipeDistance = Math.abs(touchEndX - touchStartX);
      const minSwipeDistance = 50;

      if (swipeDistance > minSwipeDistance) {
        let currentIndex = 0;
        tagElements.forEach((tag, idx) => {
          if (tag.classList.contains('active')) {
            currentIndex = idx;
          }
        });

        if (touchEndX < touchStartX) {
          switchToTab(currentIndex + 1);
        } else if (touchEndX > touchStartX) {
          switchToTab(currentIndex - 1);
        }
      }
    }
  });

  scrollActiveTagIntoView();
});
